function initProductSwiper() {
  var productSwiper = new Swiper('.u-product-slider', {
    slidesPerView: 4,
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      1200: { slidesPerView: 4 },
      992: { slidesPerView: 3 },
      768: { slidesPerView: 2 },
      250: { slidesPerView: 1 }
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  function aggiornaData() {
    const doubleuspsElement = document.querySelector('.doubleusps');

    // Staat het USP-blok niet op deze pagina, dan is er simpelweg niets te
    // doen. Dat is geen fout, dus ook geen console.error meer.
    if (!doubleuspsElement) {
      return;
    }
    const giorniDellaSettimana = doubleuspsElement.dataset.giorni.split(',');
    const mesi = doubleuspsElement.dataset.mesi.split(',');
    const nDays = window.nDays || 1;

    const ora = new Date();
    const futureDate = new Date(ora);
    futureDate.setDate(ora.getDate() + nDays); 

    const dataFormattata = `${giorniDellaSettimana[futureDate.getDay()]}, ${futureDate.getDate()} ${mesi[futureDate.getMonth()]}`;
    
    let cstmDate = document.getElementById('cstmdate');
    if (cstmDate) {
      cstmDate.innerText = dataFormattata;
    }

    const msFinoAllaMezzanotte = new Date(ora.setHours(24, 0, 0, 0)) - ora;
    setTimeout(() => {
      aggiornaData();
      setInterval(aggiornaData, 24 * 60 * 60 * 1000);
    }, msFinoAllaMezzanotte);
  }

  aggiornaData();
});